import React, { useEffect, useRef } from 'react';
import style from './Popup.module.css';


const Popup = props => {
    const main = useRef();

    useEffect(() => {
        if (props.show) {
            main.current.style.transitionProperty = "";
            main.current.style.background = "rgba(0,0,0,0.3)";
        }
        else {
            main.current.style.transitionProperty = "transform";
            main.current.style.background = "";
        }
    }, [props.show]);

    return <main className={ style.main } style={{ ...props.style, transform: props.show && "translateY(0)" }} ref={ main } onClick={ props.onClick }>
        <div className={ style.popup }>
            { props.icon && <img src={ props.icon } className={ style.icon } style={{ width: props.iconDimension && props.iconDimension, height: props.iconDimension && props.iconDimension }}></img> }
            <h4 className={ style.text }>{ props.text }</h4>
            { props.buttons }
        </div>
    </main>
};

export default Popup;
